import React from "react";
import {TableRow, TableCell} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

const SkeletonFrame = () => {
  return (
    <>
      <Skeleton variant="text" width={100} height={20} />
      <Skeleton variant="text" width={240} height={24} />
    </>
  );
};

type SkeletonTableCellType = {
  row: number;
  column: number;
};

const SkeletonTableCell = ({row, column}: SkeletonTableCellType) => {
  return (
    <>
      {[...Array(row)].map((row, index1) => (
        <TableRow key={index1}>
          {[...Array(column)].map((column, index2) => (
            <TableCell key={index2} align="center">
              <SkeletonFrame />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default SkeletonTableCell;
